import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { DoHttpService } from 'src/app/core/services/do-http.service';
import { LayoutService } from 'src/app/core/services/layout.service';
import { ApiUrls } from 'src/app/shared/constants/ApiUrls';
import { SupportUserDTO } from 'src/app/shared/interfaces/IUser';
import { LocalDateTimePipe } from 'src/app/shared/pipes/local-date-time.pipe';

@Component({
    selector: 'app-support-user-details',
    templateUrl: './support-user-details.component.html',
    styleUrls: ['./support-user-details.component.scss']
})
export class SupportUserDetailsComponent implements OnInit, OnDestroy {
  
  @Input() sidenavExpanded: boolean;
  
  supportUserDetails = new SupportUserDTO();
  subscription: Subscription;

  get supportUserDetailsMessage() {
      return `Support User is active\n
            User will be active till ${this.localDatePipe.transform(this.supportUserDetails.supportUserAcessExpiry)}\n
            User role is ${this.supportUserDetails.roleName}`;
  }

  constructor(private localDatePipe: LocalDateTimePipe,
              private request: DoHttpService,
              private layoutService: LayoutService) { }

  ngOnInit(): void {
      this.getSupportUserDetails();
      this.subscription = this.layoutService.$supportUserStatusChange.subscribe(res => {
          this.getSupportUserDetails();
      })
  }

  getSupportUserDetails() {
      this.request.get(ApiUrls.getSupportEnabledApi).subscribe(res => {
          this.supportUserDetails = res;
          if (this.supportUserDetails.isSupportEnabled) {
              let timeForExpiry = new Date(this.localDatePipe.transform(this.supportUserDetails.supportUserAcessExpiry, null)).getTime() - new Date().getTime();
              // This is max limit for setTimout
              timeForExpiry = timeForExpiry > 200000000 ? 200000000 : timeForExpiry;
              setTimeout(() => {
                  this.getSupportUserDetails();
              }, timeForExpiry);
          }
      });
  }

  ngOnDestroy(): void {
      this.subscription?.unsubscribe();
  }

}
